import { render, staticRenderFns } from "./UpgradeToKYCDetail.vue?vue&type=template&id=67eba9f1&scoped=true&"
import script from "./UpgradeToKYCDetail.vue?vue&type=script&lang=js&"
export * from "./UpgradeToKYCDetail.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeToKYCDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UpgradeToKYCDetail.vue?vue&type=style&index=1&id=67eba9f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eba9f1",
  null
  
)

export default component.exports